import { render, staticRenderFns } from "./Fastbot.vue?vue&type=template&id=1ccbd53b&scoped=true"
import script from "./Fastbot.vue?vue&type=script&lang=ts"
export * from "./Fastbot.vue?vue&type=script&lang=ts"
import style0 from "./Fastbot.vue?vue&type=style&index=0&id=1ccbd53b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbd53b",
  null
  
)

export default component.exports